export default __webpack_public_path__ + "static/media/File-Number-6.9f22be4c.pdf";